import React, { useEffect } from "react";
import { Trash } from "phosphor-react";
import { useDispatch } from "react-redux";
import "./deletecartitembtn.css";
import { deleteUserCart, getUserCart } from "../../appState/slices/cart/cartSlice";

const DeleteCartItemBtn = ({ styleclass, productid, cartid, quantity }) => {
  const dispatch = useDispatch();

  const deleteCartItem = async () => {
    try {
      // Dispatch the action to delete the cart item
      await dispatch(deleteUserCart({ productId: productid, quantity: quantity, cartItemId: cartid }));

      // Refresh cart data after successful deletion
      dispatch(getUserCart());
    } catch (error) {
      console.error("Error deleting cart item:", error);
      // Handle the error, e.g., show an error message to the user
    }
  };

  useEffect(() => {
    // You can include additional logic here if needed
  }, []);

  return (
    <div>
      <div className={`delete-button ${styleclass}`} onClick={deleteCartItem}>
        <Trash />
      </div>
    </div>
  );
};

export default DeleteCartItemBtn;
